import React from "react";
import { Link } from "react-router-dom";

import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";

import styles from "./not-found.module.scss";

const ErrorPage = ({ error }) => (
  <div className={styles.container}>
    <h1>
      <Trans>Uh oh!</Trans>
    </h1>
    <hr />
    <p>
      <ErrorMessage error={error} />
      <Link to="/">
        <Trans>Return home</Trans>
      </Link>
    </p>
  </div>
);

export default ErrorPage;
